import { trackProductEvent, type AnalyticsProperties } from '@/lib/analytics';

export const trackManualMealPlanSetupViewed = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Setup Viewed', properties);
};

export const trackManualMealPlanClientSelected = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Client Selected', properties);
};

export const trackManualMealPlanClientGoalsEditClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Client Goals Edit Clicked', properties);
};

export const trackManualMealPlanDietaryPreferencesEditClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Dietary Preferences Edit Clicked', properties);
};

export const trackManualMealPlanClientGoalsSaved = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Client Goals Saved', properties);
};

export const trackManualMealPlanDietaryPreferencesSaved = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Dietary Preferences Saved', properties);
};

export const trackManualMealPlanSlotAdded = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Slot Added', properties);
};

export const trackManualMealPlanSlotRemoved = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Slot Removed', properties);
};

export type ManualMealPlanExitClickEvent = 'Manual Meal Plan Back Clicked' | 'Manual Meal Plan Cancel Clicked';

export const trackManualMealPlanExitClicked = (
  eventName: ManualMealPlanExitClickEvent,
  properties: AnalyticsProperties
) => {
  trackProductEvent(eventName, properties);
};

export const trackManualMealPlanCreateClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Create Clicked', properties);
};

export const trackManualMealPlanSetupCompleted = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Setup Completed', properties);
};
